import { useLingui } from '@lingui/react/macro'
import { ResizeHandle } from 'designSystem/components/ResizeHandle'
import type { KeyboardEvent, PointerEvent } from 'react'

import { MIN_PAGE_ROWS } from './sidebarPageRows'

interface EmbeddedSidebarPagesSplitHandleProps {
  maxRows: number
  onKeyDown: (event: KeyboardEvent<HTMLDivElement>) => void
  onPointerDown: (event: PointerEvent<HTMLDivElement>) => void
  rows: number
}

export function EmbeddedSidebarPagesSplitHandle({
  maxRows,
  onKeyDown,
  onPointerDown,
  rows,
}: EmbeddedSidebarPagesSplitHandleProps) {
  const { t } = useLingui()

  return (
    <ResizeHandle
      size='compact'
      tone='muted'
      role='separator'
      aria-label={t`Resize pages and recent chats`}
      aria-orientation='horizontal'
      aria-valuemin={MIN_PAGE_ROWS}
      aria-valuemax={maxRows}
      aria-valuenow={rows}
      tabIndex={0}
      onKeyDown={onKeyDown}
      onPointerDown={onPointerDown}
    />
  )
}
